import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
export default function Sitemap() {
  const sections = [{
    title: 'Main Pages',
    links: [{
      label: 'Home',
      path: '/'
    }, {
      label: 'About Dr. Syed',
      path: '/about'
    }, {
      label: 'Contact Us',
      path: '/contact'
    }, {
      label: 'FAQs',
      path: '/faq'
    }]
  }, {
    title: 'Our Services',
    links: [{
      label: 'All Services',
      path: '/services'
    }, {
      label: 'Mental Capacity Assessments',
      path: '/services/mental-capacity'
    }, {
      label: 'Trauma & PTSD Evaluations',
      path: '/services/trauma-ptsd'
    }, {
      label: 'Neurodevelopmental Assessments (ADHD & ASD)',
      path: '/services/neurodevelopmental'
    }, {
      label: 'Forensic & Risk Assessments',
      path: '/services/forensic-risk'
    }, {
      label: 'Specialist Psychiatric Evaluations',
      path: '/services/specialist'
    }, {
      label: 'Clinical Negligence Cases',
      path: '/services/clinical-negligence'
    }]
  }, {
    title: 'Policies',
    links: [{
      label: 'Privacy & Cookie Policy',
      path: '/policies/privacy'
    }, {
      label: 'Terms & Conditions',
      path: '/policies/terms'
    }, {
      label: 'Cancellation Policy',
      path: '/policies/cancellation'
    }]
  }];
  return <main className="min-h-screen bg-white" data-id="element-1492">
      <Helmet data-id="element-1493">
        <title data-id="element-1494">Sitemap | Medicolegal Psychiatry</title>
        <meta name="description" content="Full sitemap for Medicolegal Psychiatry. Browse all pages including services, policies, and contact information." data-id="element-1495" />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-1496">
        <div className="container mx-auto px-4" data-id="element-1497">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-center" data-id="element-1498">
            Sitemap
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center mt-4" data-id="element-1499">
            A complete overview of all pages on our website
          </p>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-12" data-id="element-1500">
        <div className="container mx-auto px-4" data-id="element-1501">
          <div className="max-w-3xl mx-auto" data-id="element-1502">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-1503">
              {sections.map(section => <div key={section.title} data-id="element-1504">
                  <h2 className="text-xl font-serif font-bold text-primary mb-4 pb-2 border-b-2 border-secondary" data-id="element-1505">
                    {section.title}
                  </h2>
                  <ul className="space-y-3" data-id="element-1506">
                    {section.links.map(link => <li key={link.path} data-id="element-1507">
                        <Link to={link.path} className="text-slate-dark hover:text-primary hover:underline transition-colors duration-200" data-id="element-1508">
                          {link.label}
                        </Link>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </main>;
}